import React, { useState } from 'react';
import './ManagementStaff.css';

const ManagementStaff = () => {
  const [expanded, setExpanded] = useState({});

  const toggleReadMore = (id) => {
    setExpanded(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const staff = [
    {
      id: 'moses',
      name: 'Hon Moses O.T. Owharo',
      position: 'Chairman of the Board / Director',
      image: '/images/Hon-Moses.jpeg',
      bio: `ABVIG is proud to have as its Chairman of the Board Mr. Moses Owharo, a distinguished business and social entrepreneur with a wealth of experience in the fields of Microfinance, Healthcare, and General Business. With certificates from both the prestigious Harvard Business School and George Washington University in the United States, Mr. Owharo brings a wealth of knowledge and expertise to the organization. In addition, Mr. Owharo is the President and CEO of ASPI, a testament to his exceptional leadership abilities.

      Mr. Owharo's accomplishments extend beyond the business world. He has also made significant contributions in the political arena, having been elected as the Executive President of the All Nigerian Community in Ghana by the Electoral Commission of Ghana. The ANC-GH is the umbrella organization for over four million Nigerians in Ghana, including corporate bodies. Mr. Owharo's reputation as a leader has enabled him to successfully lobby prominent political figures in Nigeria and Ghana, including former Presidents Goodluck Jonathan, Atta Mills, John Mahama, J.J. Rawlings, and J.A. Kufuor, as well as various ministers of state, chief directors of ministries, and corporate leaders of local and international organizations.

      Under Mr. Owharo's leadership, the GMG has executed successful projects for various organizations, including the USAID, Ghana Government Health Service, Ministry of Food and Agriculture, and the UN-World Food Program. As the founder of the International Community of Africans in Diaspora (ICAD), Mr. Owharo has continued to promote the welfare and interests of Africans in the Diaspora.

      Mr. Owharo is a consultant representing West Africa on steel factory establishment in Africa for Freshvale Limited, Russia. He serves as a Board Member for both the Ghana-Nigeria Economic Group and the Nigerians in Diaspora Organization (NIDO), representing various financial investment groups globally. He has also held various leadership positions, including Coordinator-Africa, Diaspora Presidential Support Committee (PSC) 2019, Presidential Liaison Officer for Africa-Diaspora, Aso Rock, Abuja-Nigeria, and member of the AU-ECOSOCC COVID-19 Response Team.`
    },
  
     {
       id: 'sam',
       name: 'Mr Oscar Sam Ugoh',
       position: 'Senior Special Adviser on Government & Strategic Institutional Relations (Africa)',
       image: '/images/Oscar-Sam-Ugoh.jpg',
      bio: `Mr. Oscar Sam Ugoh serves as Senior Special Adviser on Government & Strategic Institutional Relations (Africa) to the Planning & Organizing Committee of the Africa Infrastructure, Climate Change, Security & Green Investment Summit (AICIS) 2026, under the strategic leadership of Africa Business Ventures & Investment Group (ABVIG). 

     In this advisory role, he supports sovereign engagement, institutional outreach, and strategic stakeholder mobilisation across African governments and regional organisations, contributing to diplomatic engagement, strategic partnerships, and the advancement of climate-aligned infrastructure and green investment initiatives associated with AICIS 2026.`
     },
    {
      id: 'franka',
      name: 'Mrs. Franka Ukpaima',
      position: 'Consultant, Special Advisor Security & Protocol',
      image: '/images/FRANCA-UKPAIMA.jpg',
      bio: `Mrs. Franka Ukpaima is a distinguished professional who brings a wealth of experience to ABVIG. She serves as a Consultant and Special Advisor on Security and Protocol matters.

      With a strong background in the banking sector, Mrs. Ukpaima is a former banker at Zenith Bank, where she honed her expertise in financial operations, client relations, and strategic management. Her experience in the banking industry has equipped her with exceptional skills in risk management, protocol, and security coordination.

      As Special Advisor on Security and Protocol, she provides expert guidance on security matters and protocol procedures, ensuring that ABVIG maintains the highest standards of professionalism and safety in all its operations. Her extensive network and experience make her an invaluable asset to the organization.`
    },
    {
      id: 'ayo',
      name: 'Dr. Ayo Ayoola-Amale',
      position: 'Government Project Development & Finance Liaison Advisor.',
      image: '/images/Ayoola-Amale.jpg',
     bio: `Dr. Ayoola-Amale serves as  to ABVIG under a fixed-term advisory appointment in connection with AICIS 2026 and related strategic investment initiatives.

   //   She provides high-level advisory support on government engagement, policy alignment, ESG integration, conflict-sensitive project structuring, and finance-readiness positioning for development and infrastructure projects. Her role is strategic and facilitative in nature and does not include executive authority, financial control, equity ownership, or signing mandate on behalf of ABVIG. All contractual and binding approvals remain under the exclusive authority of the Chairman/CEO and Board.
Dr. Ayoola-Amale holds a PhD and is a qualified Attorney with extensive experience in governance advisory, conflict resolution, stakeholder mediation, and institutional facilitation. She has served as a Master Trainer/Facilitator and International Election Observer, supporting governance systems, policy engagement, and multilateral dialogue processes. Her expertise strengthens institutional risk management, regulatory alignment, and socially responsible investment positioning. She does not act as an authorized signatory, beneficial owner, or financial obligor of ABVIG.
`
    },

    {
      id: 'pius',
      name: 'Mr. Pius John Ugbaje',
      position: 'Administrative Assistant',
      image: '/images/pius-john-ugbaje.png',
      bio: `John, an esteemed Assistant Administrative Officer, boasts a Bachelor of Science Degree in Information Technology from the illustrious University of Ghana, Legon. He exhibits exceptional skills in troubleshooting computer and network-related issues and provides invaluable support to the CEO at ABVIG in Ghana, including conducting extensive online research on businesses and information.

      A consummate professional, John is committed to delivering outstanding administrative assistance, ensuring the smooth running of daily operations. He takes great pleasure in exploring the vast depths of the internet, reading insightful blogs and eagerly embraces novel challenges that enhance his knowledge and proficiency in various skill sets.

      John holds a profound belief that every human interaction presents an opportunity for kindness, and he continuously strives to infuse this philosophy into his work and personal life.`
    },
 
    {
      id: 'lara',
      name: 'Achu Larrisa',
      position: 'Manager – Human Resources, Digital Communications & Business Promotion.',
      image: '/images/lara.jpeg',
      bio: `Achu Larissa Bih serves as Manager, Human Resources, Digital Communications & Business Promotion at Africa Business Ventures & Investment Group (ABVIG). In this role, she supports organisational development, staff coordination, and digital communication strategies that promote ABVIG programmes and institutional initiatives, including the Africa Infrastructure, Climate Change, Security & Green Investment Summit (AICIS).

     Larissa brings professional experience in human resource management, operations leadership, and digital media engagement across multiple sectors. She contributes to strengthening internal administrative systems, workforce development, and online visibility for ABVIG’s development and investment platforms.
She holds a Master’s Degree in Human Resource Management and is committed to advancing organisational effectiveness through people management, communication, and strategic digital engagement.`
    },

    {
      id: 'Ife',
      name: 'Ifeoluwa Balogun',
      position: 'Administrative Manager.',
      image: '/images/ife.jpeg',
      bio: `Ifeoluwa Balogun is an Administrative Officer at ABVIG, passionate about effective administration, operational excellence, and creating organized systems that drive productivity. With strong skills in coordination, communication, problem-solving, and stakeholder engagement, she is committed to ensuring seamless day-to-day operations and delivering results.

A proactive, detail-oriented, and people-focused approach, with a strong desire to contribute meaningfully to the organization’s growth and impact.`
    },

    
    {
      id: 'david',
      name: 'Enaburekhan David Munachi',
      position: 'ICT & Digital Business Development Officer',
      image: '/images/david-enabs.jpeg',
      bio: `David Enabs is an ICT & Digital Business Development Officer with expertise in software and web development, digital transformation, business development, and technology-driven solutions. He specializes in designing scalable digital platforms, optimizing business processes, and implementing innovative technologies that drive organizational growth and operational efficiency.

      Passionate about digital innovation, David combines technical expertise with strategic business insight to support institutional development, strengthen digital infrastructure, and deliver impactful technology solutions across diverse sectors. His commitment to excellence and innovation makes him an essential part of the ABVIG team, driving the organization's digital transformation initiatives.`
    },

    {
      id: 'Joseph',
      name: 'Ibitomi Joseph',
      position: 'AI Automation Specialist.',
      image: '/images/joseph.jpeg',
      bio: `Joseph is an AI Automation Specialist with expertise in workflow automation, AI-powered systems, CRM optimization, and business process improvement. He specializes in designing and implementing intelligent workflows that connect business tools, automate repetitive processes, streamline operations, and improve customer experiences.
            With experience across platforms such as n8n, Make, Zapier, HubSpot, Airtable, and AI technologies, Joseph combines technical problem-solving with a strong understanding of business operations. 
      He is passionate about using AI and automation to reduce manual work, improve operational efficiency, strengthen customer support systems, and help businesses build scalable digital processes. His commitment to innovation and practical automation makes him a valuable contributor to digital transformation and technology-driven business initiatives.`
    },

    {
      id: 'Emmanuel',
      name: 'Engr. Emmanuel Alphonsus Udoette',
      position: 'Health & Technology Integration Consultant – ABVIG / ASPI.',
      image: '/images/emmanuel.jpeg',
      bio: `Engr. Emmanuel Alphonsus Udoette is a Health & Technology Integration Consultant with ABVIG and ASPI. A Chemical Engineering graduate of the University of Port Harcourt, he combines engineering expertise with experience in Health Information Technology, digital health systems, and technology-driven business development.
      
      He has supported the deployment of EMR and ERP systems across healthcare facilities, contributing to improved data management, operational efficiency, and digital healthcare delivery.

He is also trained in web consulting and digital business development through SnapiLabs, with expertise in digital strategy, web-based solutions, and technology integration.`
    },


    {
      id: 'joy',
      name: 'Joy Olivia ',
      position: 'Office Maintenance Assistant',
      image: '/images/joy-olivia.jpeg',
      bio: `Olivia Joy is a dedicated support staff member of Africa Business Ventures & Investment Group (ABVIG), serving as an Office Maintenance Assistant. She supports the effective day-to-day operation of the organization by maintaining a clean, hygienic, safe, and orderly working environment.

      Her responsibilities include cleaning and maintaining office premises and facilities, ensuring appropriate hygiene standards, assisting with minor office maintenance activities, promptly reporting maintenance issues, and providing general operational support as assigned by management.
Through her commitment, reliability, and attention to workplace cleanliness, Olivia contributes to creating a professional, healthy, and conducive working environment for ABVIG staff, partners, and visitors.
`
    }
  ];

  return (
    <div>
      <section className="page-hero">
        <h1>Management Staff</h1>
        <p>Our dedicated management team</p>
      </section>

      <section className="staff-page-section">
        <div className="container">
          <div className="staff-list">
            {staff.map((member) => (
              <div className="staff-card" key={member.id}>
                <div className="staff-image" style={{backgroundImage: `url(${member.image})`}}></div>
                <div className="staff-info">
                  <h3>{member.name}</h3>
                  <p className="staff-position">{member.position}</p>
                  <div className="staff-bio">
                    <p className="staff-summary">
                      {expanded[member.id] 
                        ? member.bio 
                        : member.bio.split('\n\n')[0] + (member.bio.split('\n\n').length > 1 ? '...' : '')}
                    </p>
                    {member.bio.split('\n\n').length > 1 && (
                      <button 
                        className="read-more-btn" 
                        onClick={() => toggleReadMore(member.id)}
                      >
                        {expanded[member.id] ? 'Read Less' : 'Read More'}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ManagementStaff;